import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGear = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-outer",
		d: "M18.1789 7.9909L18.3124 8.39959L18.7325 8.49092L20.25 8.82081V12.1792L18.7325 12.5091L18.3124 12.6004L18.1789 13.0091C18.0506 13.4019 17.8916 13.7853 17.7039 14.1547L17.5089 14.5382L17.7416 14.9001L18.5817 16.2069L16.2069 18.5817L14.9001 17.7416L14.5382 17.5089L14.1547 17.7039C13.7853 17.8916 13.4019 18.0506 13.0091 18.1789L12.6004 18.3124L12.5091 18.7325L12.1792 20.25H8.82081L8.49092 18.7325L8.39959 18.3124L7.9909 18.1789C7.59807 18.0506 7.21471 17.8916 6.84532 17.7039L6.46179 17.5089L6.09988 17.7416L4.79308 18.5817L2.41832 16.2069L3.25844 14.9001L3.4911 14.5382L3.29614 14.1547C3.10837 13.7853 2.94938 13.4019 2.82107 13.0091L2.68759 12.6004L2.26746 12.5091L0.75 12.1792V8.82081L2.26746 8.49092L2.68759 8.39959L2.82107 7.9909C2.94938 7.59807 3.10837 7.21471 3.29614 6.84532L3.4911 6.46179L3.25844 6.09988L2.41832 4.79308L4.79308 2.41832L6.09988 3.25844L6.46179 3.4911L6.84532 3.29614C7.21471 3.10837 7.59807 2.94938 7.9909 2.82107L8.39959 2.68759L8.49092 2.26746L8.82081 0.75H12.1792L12.5091 2.26746L12.6004 2.68759L13.0091 2.82107C13.4019 2.94938 13.7853 3.10837 14.1547 3.29614L14.5382 3.4911L14.9001 3.25844L16.2069 2.41832L18.5817 4.79308L17.7416 6.09988L17.5089 6.46179L17.7039 6.84532C17.8916 7.21471 18.0506 7.59807 18.1789 7.9909ZM16.1369 18.6517C16.1369 18.6517 16.137 18.6516 16.1371 18.6515L16.1369 18.6517ZM8.84182 20.3467L8.8418 20.3466L8.84182 20.3467Z",
		fill: "white",
		stroke: "inherit",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("circle", {
		className: "icon-inner",
		cx: 10.5,
		cy: 10.5,
		r: 3.75,
		fill: "white",
		stroke: "inherit",
		strokeWidth: 1.5
	})]
});
export default SvgGear;
